module.exports = __webpack_public_path__ + "img/car.f3b5b94d.png";